// import React, { useState, useEffect } from "react";
// import "./OrgChartGiq.css";

// const OrgChartGiq = ({ data }) => {
//   const [treeData, setTreeData] = useState(null);
//   const [selectedNode, setSelectedNode] = useState(null);

//   useEffect(() => {
//     if (data) {
//       setTreeData(data);
//     }
//   }, [data]);

//   const handleNodeClick = (node) => {
//     setSelectedNode(node);
//   };

//   const handleClose = () => {
//     setSelectedNode(null);
//   };

//   const renderTree = (node) => {
//     if (!node) return null;
//     const hasChildren = node.children && node.children.length > 0;

//     return (
//       <li key={node.id}>
//         <div className="node person-node" onClick={() => handleNodeClick(node)}>
//           <strong>{node.name}</strong>
//           {node.title && <div className="title">{node.title}</div>}
//         </div>
//         {hasChildren && (
//           <ul>{node.children.map((child) => renderTree(child))}</ul>
//         )}
//       </li>
//     );
//   };

//   return (
//     <>
//       <div className="org-chart">
//         {treeData ? <ul>{renderTree(treeData)}</ul> : <p>No data</p>}
//       </div>

//       {/* Bootstrap Modal */}
//       {selectedNode && (
//         <div
//           className="modal fade show d-block org_chart_modal_wrapper"
//           tabIndex="-1"
//           role="dialog"
//         >
//           <div className="modal-dialog" role="document">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <div className="emp_info_block">
//                   <div className="emp_icon">
//                     <img
//                       src="/img/man_avatar.png"
//                       alt="icon"
//                       className="emp_icon_img"
//                     />
//                   </div>
//                   <div className="emp_info">
//                     <p className="emp_name">{selectedNode.name}</p>
//                     <p className="emp_desg_year">
//                       {selectedNode?.title}
//                       <span className="line">|</span> joined{" "}
//                       {selectedNode?.publication_date}
//                     </p>
//                     <p className="emp_bu">
//                       Business Unit: {selectedNode?.functional_area}
//                     </p>
//                   </div>
//                 </div>
//                 {/* <h5 className="modal-title">{selectedNode.name}</h5> */}
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={handleClose}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 {/* <p className="emp_name">
//                   <i
//                     className="fa fa-address-book-o emp_icon_img"
//                     aria-hidden="true"
//                   ></i>{" "}
//                   <span className="sub_name">Terry Valancia</span>{" "}
//                   <span className="line">|</span>{" "}
//                   <span className="dot_new">•</span>{" "}
//                   <span className="sub_name">Finance</span>{" "}
//                   <span className="sub_name">Enterprise Solutions</span>
//                 </p> */}
//                 {/* <p className="emp_mail">
//                   <i
//                     class="fa fa-envelope-o emp_icon_img"
//                     aria-hidden="true"
//                   ></i>
//                   <a href="#" className="email">
//                     test@gmail.com
//                   </a>
//                 </p> */}
//                 {/* <p className="emp_contact">
//                   <i class="fa fa-phone emp_icon_img" aria-hidden="true"></i>
//                   <a href="#" className="contact">
//                     +91-96786002
//                   </a>
//                 </p> */}
//                 <p className="emp_location">
//                   <i
//                     class="fa fa-map-marker emp_icon_img"
//                     aria-hidden="true"
//                   ></i>{" "}
//                   {selectedNode?.location}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modal backdrop */}
//       {selectedNode && <div className="modal-backdrop fade show"></div>}
//     </>
//   );
// };

// export default OrgChartGiq;

import React, { useState, useEffect, useRef } from "react";
import "./OrgChartGiq.css";

const OrgChartGiq = ({ data }) => {
  const [treeData, setTreeData] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);
  const [modalPos, setModalPos] = useState({ top: 0, left: 0 });
  const chartRef = useRef(null);

  // Ref for the scrollable wrapper (from earlier steps)
  const scrollWrapperRef = useRef(null);

  // Ref for the root parent node (the node you want to center)
  const parentNodeRef = useRef(null);

  useEffect(() => {
    // Ensure both elements exist before trying to scroll
    if (scrollWrapperRef.current && parentNodeRef.current) {
      const wrapper = scrollWrapperRef.current;
      const node = parentNodeRef.current;

      // Calculate the horizontal position needed to center the node:
      const scrollPosition =
        node.offsetLeft - wrapper.offsetWidth / 2 + node.offsetWidth / 2;

      // Perform the scroll
      wrapper.scrollLeft = scrollPosition;

      // Alternative (often simpler, but might not center perfectly):
      node.scrollIntoView({
        behavior: "instant",
        block: "nearest",
        inline: "center",
      });
    }
  }, [treeData]); // Rerun when treeData loads/changes

  useEffect(() => {
    if (data) {
      setTreeData(data);
    }
  }, [data]);

  const handleNodeClick = (node, event) => {
    const rect = event.target.getBoundingClientRect();
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const scrollX = window.scrollX || document.documentElement.scrollLeft;

    setModalPos({
      top: rect.bottom + scrollY + 8, // place just below
      left: rect.left + scrollX + rect.width / 2, // center align
    });
    setSelectedNode(node);
  };

  const handleClose = () => {
    setSelectedNode(null);
  };

  const renderTree = (node) => {
    if (!node) return null;
    const hasChildren = node.children && node.children.length > 0;

    return (
      <li key={node.id} ref={parentNodeRef}>
        <div
          className="node person-node"
          onClick={(e) => handleNodeClick(node, e)}
        >
          <strong>{node.name}</strong>
          {node.title && <div className="title">{node.title}</div>}
        </div>
        {hasChildren && (
          <ul>{node.children.map((child) => renderTree(child))}</ul>
        )}
      </li>
    );
  };

  return (
    <>
      <div className="org-chart">
        <div className="org-chart-scroll-wrapper" ref={scrollWrapperRef}>
          <div className="org-chart-content">
            {treeData ? <ul>{renderTree(treeData)}</ul> : <p>No data</p>}
          </div>
        </div>
      </div>

      {/* Inline popover modal */}
      {selectedNode && (
        <div
          className="org-chart-popover org_chart_modal_wrapper"
          style={{
            top: modalPos.top,
            left: modalPos.left,
            position: "absolute",
            transform: "translateX(-50%)",
            zIndex: 2000,
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <div className="emp_info_block">
                <div className="emp_icon">
                  <img
                    src="/img/man_avatar.png"
                    alt="icon"
                    className="emp_icon_img"
                  />
                </div>
                <div className="emp_info">
                  <p className="emp_name">{selectedNode.name}</p>
                  <p className="emp_desg_year">
                    {selectedNode?.title}
                    <span className="line">|</span> joined{" "}
                    {selectedNode?.publication_date}
                  </p>
                  <p className="emp_bu">
                    Business Unit: {selectedNode?.functional_area}
                  </p>
                </div>
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="emp_location">
                <i
                  className="fa fa-map-marker emp_icon_img"
                  aria-hidden="true"
                ></i>{" "}
                {selectedNode?.location}
              </p>
            </div>
          </div>
          {/* optional pointer arrow */}
          <div className="popover-arrow"></div>
        </div>
      )}
    </>
  );
};

export default OrgChartGiq;
